<template>
    <span :class="['d-inline-block', strong ? 'eyebrow-strong' : 'eyebrow', primary ? 'eyebrow-primary' : null]">
        <slot>{{ text }}</slot>
    </span>
</template>

<script>
export default {
    name: 'Eyebrow',
    props: {
        text: {
            type: String,
            default: '',
        },
        strong: {
            type: Boolean,
            default: false,
        },
        primary: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
